import { render, staticRenderFns } from "./CommitteeView.vue?vue&type=template&id=7ec845d3&scoped=true&"
import script from "./CommitteeView.vue?vue&type=script&lang=js&"
export * from "./CommitteeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec845d3",
  null
  
)

export default component.exports